import { render, staticRenderFns } from "./orderItemEdgeworkPopover.vue?vue&type=template&id=ac53f46c&scoped=true&"
import script from "./orderItemEdgeworkPopover.vue?vue&type=script&lang=js&"
export * from "./orderItemEdgeworkPopover.vue?vue&type=script&lang=js&"
import style0 from "./orderItemEdgeworkPopover.vue?vue&type=style&index=0&id=ac53f46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac53f46c",
  null
  
)

export default component.exports